import React from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
const Infrastructure = () => {
  return (
    <>
      <HeadTag title="Infrastructure" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/">
                {" "}
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span> Infrastructure</span>
            </h5>
            <h2> Infrastructure </h2>
          </div>
          <div className="row img_data_sec">
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/CLASSROOM.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/CLASSROOM.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>CLASSROOM</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/ICT-LAB.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/ICT-LAB.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>ICT LAB</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/INFIRMARY.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/INFIRMARY.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>INFIRMARY</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/CAFETERIA.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/CAFETERIA.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>CAFETERIA</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/OPEN AIR AMPHITHEATRE.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/OPEN AIR AMPHITHEATRE.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>OPEN AIR AMPHITHEATRE</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/JUNGLE GYM.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/JUNGLE GYM.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>JUNGLE GYM</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Biology-Lab.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Biology-Lab.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>BIOLOGY LAB</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Chemistry-Lab.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Chemistry-Lab.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>CHEMISTRY LAB</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Physics-Lab.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Physics-Lab.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>PHYSICS LAB</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/SPLASH POOL.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/SPLASH POOL.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>SPLASH POOL</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Library.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Library.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Library</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Astronomy.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Astronomy.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Astronomy</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/basket-ball.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/basket-ball.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Basket Ball</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/chess.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/CHESS.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Chess</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/computer-lab.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/computer-lab.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Computer Lab</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Football.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/FOOTBALL.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Football</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/lawn-tennis.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/lawn-tennis.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Lawn Tennis</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Open-Library.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Open-Library.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Open Library</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Skating.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/SKATING.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Skating</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/STEAM.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/STEAM.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Steam</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Swimming.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Swimming.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Swimming</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Table-Tennis.JPG"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Table-Tennis.JPG"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Table Tennis</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="box">
                {" "}
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Taekwondo.jpg"
                >
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/Taekwondo.jpg"
                      className="img-fluid"
                      alt="Lotus Valley International School, Greater Noida"
                    />
                  </LazyLoad>
                </a>
                <h4>Taekwondo</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Infrastructure;
